/**
 * Open-box "used stock available" banner on the New PDP.
 *
 * window.USED_MAP (baked into the cached page from the New parent's custom.used_map
 * metafield) lists every config that has a companion: { handle, from, label }. Live
 * in-stock truth comes from Shopify's own /products/{handle}.js — same origin, works
 * for Unlisted products via direct handle, and reflects the same inventory the cart
 * uses. No MK backend call. Fails closed so a cached page never shows a dead link.
 *
 * The hero banner (.used-banner__link) points at the primary companion — the selected
 * variant's if it has one in stock, else the first in-stock config. The other in-stock
 * configs are listed in .used-banner__more, so companions for sold-out (and therefore
 * unselectable) variants are still reachable. That was the bug: a single selection-
 * driven link stranded every config except one.
 */
(function () {
  var stockByHandle = {}; // handle -> Promise<boolean>, cached so variant clicks don't re-fetch
  var updateToken = 0;

  function companionInStock(handle) {
    if (!stockByHandle[handle]) {
      stockByHandle[handle] = fetch('/products/' + handle + '.js')
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (product) {
          return !!product && (product.variants || []).some(function (v) { return v.available; });
        })
        .catch(function () { return false; }); // fail closed — never show a dead link
    }
    return stockByHandle[handle];
  }

  // De-duped companion entries, selected variant's companion first.
  function orderedEntries(map, selectedSku) {
    var seen = {};
    var entries = [];
    var selected = selectedSku && map[selectedSku];
    if (selected && selected.handle) { entries.push(selected); seen[selected.handle] = true; }
    Object.keys(map).forEach(function (sku) {
      var e = map[sku];
      if (e && e.handle && !seen[e.handle]) { entries.push(e); seen[e.handle] = true; }
    });
    return entries;
  }

  async function updateBanner(selectedSku) {
    var banner = document.getElementById('used-banner');
    if (!banner) return;

    var link = banner.querySelector('.used-banner__link');
    var fromEl = banner.querySelector('.used-banner__from');
    var more = banner.querySelector('.used-banner__more');

    var token = ++updateToken;
    var entries = orderedEntries(window.USED_MAP || {}, selectedSku);

    // Resolve every companion's live stock in parallel.
    var flags = await Promise.all(entries.map(function (e) { return companionInStock(e.handle); }));
    if (token !== updateToken) return; // superseded by a newer variant change

    var inStock = entries.filter(function (e, i) { return flags[i]; });
    if (!inStock.length) {
      banner.hidden = true;
      if (more) { more.innerHTML = ''; more.hidden = true; }
      return;
    }

    // Hero → the selected variant's companion if in stock, else the first in-stock config.
    var primary = inStock[0];
    if (link) link.setAttribute('href', '/products/' + primary.handle);
    if (fromEl) fromEl.textContent = primary.from ? ' — from $' + primary.from : '';

    // The remaining in-stock configs, named, so every one is reachable.
    if (more) {
      more.innerHTML = '';
      var rest = inStock.slice(1);
      rest.forEach(function (e) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'used-banner__more-link';
        a.setAttribute('href', '/products/' + e.handle);
        a.setAttribute('rel', 'nofollow');
        a.textContent = (e.label || 'Open box') + (e.from ? ' — from $' + e.from : '');
        li.appendChild(a);
        more.appendChild(li);
      });
      more.hidden = rest.length === 0;
    }

    banner.hidden = false;
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!document.getElementById('used-banner')) return;

    // Initial check for the pre-selected variant.
    updateBanner(window.USED_INITIAL_SKU);

    // Re-check on variant change. The theme's VariantSelects 'change' handler is
    // registered in its constructor (before this one), so el.currentVariant is set.
    document.querySelectorAll('variant-radios, variant-selects').forEach(function (el) {
      el.addEventListener('change', function () {
        updateBanner(el.currentVariant && el.currentVariant.sku);
      });
    });
  });
})();
